import * as Sentry from "@sentry/react";
import config from "../config";

export function logForSentry (errorMessage, tagsObj = {}, contextObj) {
    Sentry.withScope(function (scope) {
        scope.setContext('context', contextObj);
        Sentry.captureMessage(errorMessage, { tags: tagsObj });
    });
}

export const logToCloudWatch = async (startTime, endTime, website) => {
    const logger = config.cloudwatch_logger;
    const stream_name_suffix = config.cloudwatch_stream_name_suffix;
    const duration = (endTime.getTime() - startTime.getTime()) / 1000;
    const data = JSON.stringify({
        logger: logger,
        stream_name_suffix: stream_name_suffix,
        info: {
            duration: duration,
            website: website
        }
    });

    await fetch(`${config.cloudwatch_endpoint_url}`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: data,
    });
}